import React from "react";
import "./projectList.css";
import Project from "../project/Project";
import { products } from "../../data";
// import ProjectList from "./components/projectList/ProjectList";

const ProjectList = () => {
  return (
    <div className="pl">
      <div className="pl-texts">
        <h1 className="pl-title">Let's see my Projects </h1>
        <div className="line-wrapper">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="line"></div>

        </div>
        <p className="pl-desc">
        Following is the work I enjoy doing, to which I put all my heart and hard work into!!
        </p>
      </div>
      {/* <div className="filter">
        <div className="filter-btn">All Projects</div>
        <div className="filter-btn">Web Applications</div>
        <div className="filter-btn">Mobile Applications</div>
        <div className="filter-btn">UI/UX Projects</div>
      </div> */}
      <div className="pl-list">
        {products.map((item) => (
          <Project key={item.id} img={item.img} link={item.link}  />
        ))}
      </div>
    </div>
  );
};

export default ProjectList;
